'use client'

import { useState } from 'react'
import { Ruler } from 'lucide-react'

import Modal from '@/components/Modal/Modal'
import SettingsDialogTrigger from '@/components/Settings/SettingsDialogTrigger'
import { settingsConfigHelp } from '@/components/Settings/configHelp'

import CustomizationElementSettingsForm from './CustomizationElementSettingsForm'

const CustomizationElementSettings = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const closeModal = () => setIsModalOpen(false)

  return (
    <>
      <SettingsDialogTrigger
        icon={<Ruler size={18} />}
        label="Customization Element Size"
        help={settingsConfigHelp.customizationElementSize}
        onClick={() => setIsModalOpen(true)}
      />

      <Modal isOpen={isModalOpen} onClose={closeModal} title="Customization Element Size" closeOnOutsideClick={false}>
        <CustomizationElementSettingsForm onCancel={closeModal} onSaved={closeModal} />
      </Modal>
    </>
  )
}

export default CustomizationElementSettings
